import rison from 'rison';

import {SearchType} from '../models';
import {api} from './Api';

export const search = (text: string) => {

  return Promise.all([
    searchReport(text),
  ]).then((res: any) => {
    /*
     * res should be an array of each promise resolved
     */
    const defaultValue = {
      result: [],
      count: 0,
    };

    return res.reduce((acc: any, response: any) => {
      acc.count += response.count;
      acc.result.push(...response.result);

      return acc;
    }, defaultValue);
  }); // maybe parse result in the future
};

const _getSearchByName = (text: string): any => ({
  filters: [
    {col: "name", opr: "ct", value: text}
  ],
  columns: ["name", "uid"],
  page: 0,
  page_size: 25,
});

const _toResponse = (itemType: SearchType) => (res: any) => {
  const _mapType = (itemType: SearchType) => (o: any) => ({...o, itemType});

  return {
    ...res.data,
    result: res.data?.result?.map(_mapType(itemType)) || [],
  };
};

export const searchReport = (text: string) => {
  const query = _getSearchByName(text);
  query.columns.push('type');

  return api.get(`/report/?q=${rison.encode(query)}`).then(_toResponse(SearchType.REPORT));
}

export const searchUser = (text: string) => {
  const query = {
    filters: [
      {col: "first_name", opr: "fn_ct", value: text}, // full_name contains text
    ],
    columns: ["first_name", "last_name", "uid"],
    page: 0,
    page_size: 25,
  }

  return api.get(`/user/?q=${rison.encode(query)}`).then((res: any) => res.data);
}
